/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import Navbar from '../../composants/site/Navbar';
import Footer from '../../composants/site/Footer';
import API_URL from '../../apiConfig';

// Importation image locale
import contactHeroImg from '../../assets/images-sites/images.jpg';

const Contact = () => {
    const [formData, setFormData] = useState({
        nom: '',
        email: '',
        sujet: '',
        contenu: ''
    });
    const [status, setStatus] = useState({ type: '', msg: '' });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.title = "LAMP | Contact";
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ type: '', msg: '' });

        try {
            const res = await fetch(`${API_URL}/api/messages/send`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });
            const data = await res.json();
            if (data.success) {
                setStatus({ type: 'success', msg: "Votre message a été envoyé avec succès !" });
                setFormData({ nom: '', email: '', sujet: '', contenu: '' });
            } else {
                setStatus({ type: 'danger', msg: "Une erreur est survenue lors de l'envoi." });
            }
        } catch (err) {
            console.error(err);
            setStatus({ type: 'danger', msg: "Impossible de contacter le serveur." });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="site-page-contact">
            <Navbar />
            
            {/* Header Contact (Style Hero) */}
            <section className="contact-hero d-flex align-items-center position-relative overflow-hidden">
                {/* Image de fond locale à droite */}
                <div 
                    className="contact-hero-bg" 
                    style={{ backgroundImage: `url(${contactHeroImg})` }}
                ></div>
                
                <div className="container contact-hero-container py-5">
                    <div className="row align-items-center h-100">
                        {/* Texte à gauche */}
                        <div className="col-lg-7 contact-text-side animate__animated animate__fadeInLeft">
                            <h1 className="display-4 fw-bold outfit text-white mb-3">Entrons en contact</h1>
                            <p className="lead text-white opacity-85 mb-0" style={{ maxWidth: '600px' }}>
                                Que ce soit pour une demande de prière, un témoignage ou une collaboration, nous sommes à votre entière écoute pour vous accompagner.
                            </p>
                        </div>
                    </div>
                </div>
                
                {/* Couche de lumière/dégradé */}
                <div className="contact-hero-overlay"></div>
            </section>

            <section className="contact-main-section py-5 bg-light">
                <div className="container py-lg-5">
                    <div className="row g-5">
                        {/* Infos Coordonnées */}
                        <div className="col-lg-4 animate__animated animate__fadeInLeft">
                            <div className="contact-info-wrap">
                                <h3 className="fw-bold outfit text-dark mb-4">Nos Coordonnées</h3>
                                
                                <div className="info-card bg-white p-4 rounded-4 shadow-sm mb-3 border-0">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="icon-box-site bg-whatsapp text-white rounded-3 p-2 me-3">
                                            <i className="bi bi-whatsapp fs-4"></i>
                                        </div>
                                        <h6 className="fw-bold mb-0">WhatsApp</h6>
                                    </div>
                                    <p className="mb-0 text-muted">+243 000 000 000</p>
                                </div>

                                <div className="info-card bg-white p-4 rounded-4 shadow-sm mb-3 border-0">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="icon-box-site bg-primary text-white rounded-3 p-2 me-3">
                                            <i className="bi bi-envelope-at-fill fs-4"></i>
                                        </div>
                                        <h6 className="fw-bold mb-0">Email Direct</h6>
                                    </div>
                                    <p className="mb-0 text-muted">contact@lamp-edification.org</p>
                                </div>

                                <div className="info-card bg-white p-4 rounded-4 shadow-sm mb-3 border-0">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="icon-box-site bg-dark text-white rounded-3 p-2 me-3">
                                            <i className="bi bi-geo-alt-fill fs-4"></i>
                                        </div>
                                        <h6 className="fw-bold mb-0">Localisation</h6>
                                    </div>
                                    <p className="mb-0 text-muted">Kinshasa, République Démocratique du Congo.</p>
                                </div>

                                <div className="social-connect mt-5">
                                    <p className="small text-uppercase fw-bold text-muted mb-3">Suivez-nous</p>
                                    <div className="d-flex gap-2">
                                        <a href="#" className="social-link-btn bg-white shadow-sm rounded-circle"><i className="bi bi-facebook"></i></a>
                                        <a href="#" className="social-link-btn bg-white shadow-sm rounded-circle"><i className="bi bi-instagram"></i></a>
                                        <a href="#" className="social-link-btn bg-white shadow-sm rounded-circle"><i className="bi bi-youtube"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Formulaire de Contact */}
                        <div className="col-lg-8 animate__animated animate__fadeInRight">
                            <div className="contact-form-card bg-white p-4 p-lg-5 rounded-4 shadow-lg border-0">
                                {status.msg && (
                                    <div key={status.type} className={`alert alert-${status.type} alert-dismissible fade show rounded-3 shadow-none border-0`} role="alert">
                                        <i className={`bi ${status.type === 'success' ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'} me-2`}></i>
                                        {status.msg}
                                        <button type="button" className="btn-close shadow-none" onClick={() => setStatus({type:'', msg:''})}></button>
                                    </div>
                                )}

                                <form onSubmit={handleSubmit} className="row g-4">
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold small text-muted text-uppercase">Nom Complet</label>
                                        <input 
                                            type="text" 
                                            name="nom" 
                                            className="form-control form-control-lg bg-light border-0 px-4 py-3" 
                                            placeholder="Ex: Jean Mukendi" 
                                            value={formData.nom}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold small text-muted text-uppercase">Adresse E-mail</label>
                                        <input 
                                            type="email" 
                                            name="email" 
                                            className="form-control form-control-lg bg-light border-0 px-4 py-3" 
                                            placeholder="Ex: jean@mail.com" 
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label fw-bold small text-muted text-uppercase">Sujet du Message</label>
                                        <input 
                                            type="text" 
                                            name="sujet" 
                                            className="form-control form-control-lg bg-light border-0 px-4 py-3" 
                                            placeholder="Ex: Demande de prière" 
                                            value={formData.sujet}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label fw-bold small text-muted text-uppercase">Votre Message</label>
                                        <textarea 
                                            name="contenu" 
                                            className="form-control form-control-lg bg-light border-0 px-4 py-3" 
                                            rows="5" 
                                            placeholder="Écrivez ici..."
                                            value={formData.contenu}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>
                                    <div className="col-12 text-end">
                                        <button 
                                            type="submit" 
                                            className="btn btn-primary-lamp btn-lg rounded-pill px-5 py-3 fw-bold shadow-lg d-flex align-items-center justify-content-center ms-auto"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <div key="loading">
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    ENVOI...
                                                </div>
                                            ) : (
                                                <div key="send">
                                                    <i className="bi bi-send-fill me-2"></i>
                                                    ENVOYER
                                                </div>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <style>{`
                .site-page-contact {
                    background-color: #ffffff;
                }
                .contact-hero {
                    min-height: 500px;
                    padding-top: 100px; /* Ajusté pour coller au menu sans trop d'espace */
                    background: linear-gradient(135deg, #0012e2 0%, #000a60 100%);
                    color: #fff;
                }
                .contact-hero-bg {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 55%;
                    height: 100%;
                    background-size: cover;
                    background-position: center;
                    opacity: 0.6;
                    z-index: 1;
                    mask-image: linear-gradient(to left, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 100%);
                    -webkit-mask-image: linear-gradient(to left, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 100%);
                }
                .contact-hero-container {
                    position: relative;
                    z-index: 10;
                }
                .bg-whatsapp { background-color: #25D366; }
                .icon-box-site {
                    width: 50px;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .form-control:focus {
                    background-color: #fff !important;
                    box-shadow: 0 0 0 0.25rem rgba(0, 18, 226, 0.1);
                    outline: none;
                }
                .info-card {
                    transition: all 0.3s ease;
                }
                .info-card:hover {
                    transform: translateX(8px);
                    box-shadow: 0 10px 25px rgba(23, 0, 226, 0.08) !important;
                }
                .social-link-btn {
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #1700E2;
                    text-decoration: none;
                    transition: all 0.3s ease;
                }
                .social-link-btn:hover {
                    background: #1700E2;
                    color: white;
                    transform: translateY(-3px);
                }
                .btn-primary-lamp {
                    background: linear-gradient(135deg, #1700E2 0%, #0012a0 100%);
                    color: white;
                    border: none;
                    transition: all 0.3s ease;
                }
                .btn-primary-lamp:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 10px 20px rgba(23, 0, 226, 0.3);
                    color: white;
                }
                @media (max-width: 991px) {
                    .contact-hero {
                        padding-top: 110px;
                        text-align: center;
                        min-height: 350px;
                    }
                    .contact-hero-bg {
                        width: 100%;
                        opacity: 0.25;
                    }
                    .contact-text-side {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                }
            `}</style>
        </div>
    );
};

export default Contact;
